import { FC } from 'react';
import { useStore, observer } from 'base/store';
import HeaderBarDropdown from '@app/common/PageHeader/HeaderBarDropdown';
import { IconFlag } from '@base/icon';
import { Menu } from './Menu';
import styles from './index.module.less';

const Index: FC = () => {
    const { rootStore, persistStore } = useStore();
    const { country, currency, lang, ua: { isMobile } } = rootStore.state;
    const { localeList = [] } = persistStore?.state || {};

    return localeList.length === 0 ? null : (
        <HeaderBarDropdown
            triggerProps={{
                type: 'text',
                content: (
                    <div className={'flex flex-middle'}>
                        <IconFlag className={styles['trigger-flag']} code={country} size={26}/>
                        {currency}
                    </div>
                )
            }}
            menu={<Menu locale={{ country, currency, lang }} list={localeList}/>}
            placement="bottom"
            trigger={[isMobile ? 'click' : 'hover']}
            overlayStyle={{ width: 300 }}
        />
    )
};

export default observer(Index);
